import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="renewal-claims-breakdown-selector"
export default class extends Controller {
  static targets = ["checkbox", "counter", "bulkActions", "selectAll"]
  static values = {
    renewalId: String
  }

  connect() {
    this.selections = new Set()
    this.updateUI()
  }

  // Handle individual checkbox changes
  toggle(event) {
    const checkbox = event.target
    const id = checkbox.dataset.id

    if (checkbox.checked) {
      this.selections.add(id)
    } else {
      this.selections.delete(id)
    }

    this.updateUI()
  }

  // Handle cell clicks (clicking anywhere in the checkbox cell)
  toggleCell(event) {
    const id = event.currentTarget.dataset.id
    const checkbox = this.checkboxTargets.find(cb => cb.dataset.id === id)

    if (checkbox) {
      // Toggle the checkbox state
      checkbox.checked = !checkbox.checked

      // Update selection state
      if (checkbox.checked) {
        this.selections.add(id)
      } else {
        this.selections.delete(id)
      }

      this.updateUI()
    }
  }

  // Handle select all on current page
  selectAll(event) {
    const isChecked = event.target.checked

    this.checkboxTargets.forEach(checkbox => {
      const id = checkbox.dataset.id
      checkbox.checked = isChecked

      if (isChecked) {
        this.selections.add(id)
      } else {
        this.selections.delete(id)
      }
    })

    this.updateUI()
  }

  // Clear all selections
  clearAll() {
    this.selections.clear()
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    this.updateUI()
  }

  // Delete selected claims experience breakdowns
  async deleteSelected() {
    const selectedIds = [...this.selections]

    if (selectedIds.length === 0) {
      alert("Please select at least one claims experience breakdown.")
      return
    }

    if (!confirm(`Are you sure you want to remove ${selectedIds.length} claims experience breakdown(s) from this renewal?`)) {
      return
    }

    try {
      const formData = new FormData()
      selectedIds.forEach(id => {
        formData.append('selected_ids[]', id)
      })

      const response = await fetch(`/workspaces/${window.currentWorkspaceId}/renewals/${this.renewalIdValue}/remove_claims_experience_breakdowns`, {
        method: 'DELETE',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (data.success) {
        // Reload the page to show updated list
        window.location.reload()
      } else {
        alert(`Error: ${data.error}`)
      }
    } catch (error) {
      console.error('Error removing claims experience breakdowns:', error)
      alert('An error occurred while removing claims experience breakdowns.')
    }
  }

  updateUI() {
    const count = this.selections.size
    const currentPageSelected = this.checkboxTargets.filter(c => c.checked).length
    const allCurrentPageSelected = currentPageSelected === this.checkboxTargets.length && this.checkboxTargets.length > 0

    // Update counter
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = count
    }

    // Show/hide bulk actions
    if (this.hasBulkActionsTarget) {
      this.bulkActionsTarget.style.display = count > 0 ? "flex" : "none"
    }

    // Update select all checkbox
    if (this.hasSelectAllTarget && this.checkboxTargets.length > 0) {
      this.selectAllTarget.checked = allCurrentPageSelected
      this.selectAllTarget.indeterminate = currentPageSelected > 0 && !allCurrentPageSelected
    }
  }
}